// src/components/common/LoadingSpinner.jsx
import React, { useState, useEffect } from 'react';
import LoadingGif from '../../assets/images/loading.gif';

const LoadingSpinner = ({ text = "Memuat...", progress = 0 }) => {
    const [showSpinner, setShowSpinner] = useState(true);
    let displayText = text;

    // Logika untuk mengubah teks berdasarkan progress
    if (progress >= 10 && progress < 50) {
        displayText = "Memuat Data...";
    } else if (progress >= 50 && progress < 100) {
        displayText = "Memuat Gambar...";
    } else if (progress === 100) {
        displayText = `Menampilkan...`;
    }

    // Effect untuk mengatur penundaan saat loading selesai
    useEffect(() => {
        if (progress === 100) {
            const timer = setTimeout(() => {
                setShowSpinner(false);
            }, 2000); // Penundaan 2 detik (2000 ms)

            return () => clearTimeout(timer);
        }
    }, [progress]);

    if (!showSpinner) {
        return null;
    }

    return (
        <div className="absolute inset-0 z-50 flex items-center justify-center bg-gray-100">
            <div className="flex flex-col items-center justify-center p-8 bg-white rounded-2xl shadow-xl">
                <img src={LoadingGif} alt="Loading..." className="w-32 h-32 mb-4" />
                <h2 className="text-2xl font-bold text-gray-900 animate-pulse">
                    {progress}%
                </h2>
                <div className="w-full h-2 bg-gray-200 rounded-full mt-4">
                    <div
                        className="h-2 bg-blue-500 rounded-full"
                        style={{ width: `${progress}%` }}
                    ></div>
                </div>
                <p className="text-gray-500 mt-2">{displayText}.</p>
            </div>
        </div>
    );
};

export default LoadingSpinner;